<template>
  <div>
    <div v-for="item in blocks" :id="item.id" :key="item.id">
      <CmsABTest
        v-if="item.type === 'ab_test'"
        :feature-flag-key="item.value.feature_flag_key"
        :feature-flag-variations="item.value.feature_flag_variations"
      ></CmsABTest>
      <component
        :is="blockTypeComponentMapping[item.type] || null"
        v-else
        :block="item.value"
        :class="item.value.meta.root_element_classes"
      ></component>
    </div>
  </div>
</template>

<script>
import PageBlockIntro from '@saas/components/page/PageBlockIntro'
import PageBlockIntroWithStats from '@saas/components/page/PageBlockIntroWithStats'
import PageBlockHorizontalContentImage from '@saas/components/page/PageBlockHorizontalContentImage'
import PageBlockVerticalContentImage from '@saas/components/page/PageBlockVerticalContentImage'
import PageBlockLogos from '@saas/components/page/PageBlockLogos'
import PageBlockTemplates from '@saas/components/page/PageBlockTemplates'
import PageBlockTemplatesWithImage from '@saas/components/page/PageBlockTemplatesWithImage'
import PageBlockMessages from '@saas/components/page/PageBlockMessages'
import PageBlockIconGrid from '@saas/components/page/PageBlockIconGrid'
import PageBlockTimeline from '@saas/components/page/PageBlockTimeline'
import PageBlockQuotes from '@saas/components/page/PageBlockQuotes'
import PageBlockMultiSlider from '@saas/components/page/PageBlockMultiSlider'
import PageHorizontalMessages from '@saas/components/page/PageHorizontalMessages'
import PageIconGrid from '@saas/components/page/PageIconGrid'
import PageIconContainer from '@saas/components/page/PageIconContainer'
import PageContentBlocks from '@saas/components/page/PageContentBlocks'
import PageBlockContentBlocks from '@saas/components/page/PageBlockContentBlocks'
import PageTimeline from '@saas/components/page/PageTimeline'
import PageBlockPhotos from '@saas/components/page/PageBlockPhotos'
import PageQuotes from '@saas/components/page/PageQuotes'
import PageBox from '@saas/components/page/PageBox'
import PageBlockIntegration from '@saas/components/page/PageBlockIntegration'
import PageBlockHomeIntro from '@saas/components/page/PageBlockHomeIntro'
import PageBlockHorizontalLogos from '@saas/components/page/PageBlockHorizontalLogos'
import PageBlockBadges from '@saas/components/page/PageBlockBadges'
import PageBlockSlider from '@saas/components/page/PageBlockSlider'
import PageBlockComparison from '@saas/components/page/PageBlockComparison'
import PageBlockSingleComparison from '@saas/components/page/PageBlockSingleComparison'
import PageBlockCommunity from '@saas/components/page/PageBlockCommunity'
import PageBlockCourses from '@saas/components/page/PageBlockCourses'
import PageBlockCertified from '@saas/components/page/PageBlockCertified'
import PageBlockBoxes from '@saas/components/page/PageBlockBoxes'
import PageBlockFAQ from '@saas/components/page/PageBlockFAQ'
import PageBlockQuoteCTA from '@saas/components/page/PageBlockQuoteCTA'
import PageBlockScreenshotSteps from '@saas/components/page/PageBlockScreenshotSteps'
import CmsLink from '@saas/components/cms/CmsLink'
import CmsABTest from '@saas/components/cms/CmsABTest'

export default {
  name: 'CmsBlocks',
  components: {
    PageBlockCommunity,
    PageBlockSlider,
    PageBlockBadges,
    PageBlockHorizontalLogos,
    PageBlockIntroWithStats,
    PageBlockLogos,
    PageBlockHorizontalContentImage,
    PageBlockVerticalContentImage,
    PageBlockTemplates,
    PageBlockMessages,
    PageHorizontalMessages,
    PageIconGrid,
    PageIconContainer,
    PageContentBlocks,
    PageTimeline,
    PageBlockPhotos,
    PageQuotes,
    PageBox,
    PageBlockIntegration,
    PageBlockComparison,
    PageBlockHomeIntro,
    PageBlockCourses,
    PageBlockCertified,
    PageBlockFAQ,
    CmsLink,
    CmsABTest,
  },
  props: {
    blocks: {
      type: Array,
      required: true,
    },
  },
  computed: {
    blockTypeComponentMapping() {
      return {
        intro: PageBlockIntro,
        intro_with_stats: PageBlockIntroWithStats,
        horizontal_content_image: PageBlockHorizontalContentImage,
        vertical_content_image: PageBlockVerticalContentImage,
        logos: PageBlockLogos,
        templates: PageBlockTemplates,
        templates_with_image: PageBlockTemplatesWithImage,
        messages: PageBlockMessages,
        icon_grid: PageBlockIconGrid,
        content_blocks: PageBlockContentBlocks,
        timeline: PageBlockTimeline,
        photos: PageBlockPhotos,
        quotes: PageBlockQuotes,
        boxes: PageBlockBoxes,
        integration: PageBlockIntegration,
        horizontal_logos: PageBlockHorizontalLogos,
        badges: PageBlockBadges,
        slider: PageBlockSlider,
        multi_slider: PageBlockMultiSlider,
        single_comparison: PageBlockSingleComparison,
        comparison: PageBlockComparison,
        community: PageBlockCommunity,
        home_intro: PageBlockHomeIntro,
        courses: PageBlockCourses,
        certifications: PageBlockCertified,
        faq: PageBlockFAQ,
        quote_cta: PageBlockQuoteCTA,
        screenshot_steps: PageBlockScreenshotSteps,
      }
    },
  },
}
</script>
